import axios from "axios";
import {
    DiscoverParameters,
    DiscoverResponse,
    SuggestParameters,
    SuggestResponse,
    DetailsParameters,
    DetailsResponse
} from "./ngsAPITypes";
import queryString from "query-string";
import { ServiceSource } from "src/state/tree/global-configuration/reducers";

let ngsBaseURL = "";
let apiKey = "";

const stringify = (parameters) => queryString.stringify(parameters, { encode: true });

function modifyUrlParams(url: string, serviceSource: ServiceSource): string {
    if (serviceSource === "ORBIS" && !url.includes("map=")) {
        url = `${url}&map=ORBIS`;
    }

    return url;
}

export function suggest(parameters: SuggestParameters, serviceSource: ServiceSource): Promise<SuggestResponse> {
    let ngsUrl = `${ngsBaseURL}/suggest?${stringify(parameters)}&key=${apiKey}`;
    ngsUrl = modifyUrlParams(ngsUrl, serviceSource);
    const viewport = parameters.viewport;
    if (viewport) {
        const newLink = new URLSearchParams(ngsUrl);
        newLink.delete("viewport");
        newLink.append("viewport", `${viewport[1][1]},${viewport[0][0]},${viewport[0][1]},${viewport[1][0]}`);
        ngsUrl = decodeURIComponent(newLink.toString());
    }
    return axios.get<SuggestResponse>(ngsUrl).then((result) => result.data);
}

export function discover(parameters: DiscoverParameters, serviceSource: ServiceSource): Promise<DiscoverResponse> {
    let ngsUrl = `${ngsBaseURL}${parameters.link}&key=${apiKey}`;
    ngsUrl = modifyUrlParams(ngsUrl, serviceSource);
    return axios.get<DiscoverResponse>(ngsUrl).then((result) => result.data);
}

export function details(parameters: DetailsParameters, serviceSource: ServiceSource): Promise<DetailsResponse> {
    let ngsUrl = `${ngsBaseURL}/details?${stringify(parameters)}&key=${apiKey}`;
    ngsUrl = modifyUrlParams(ngsUrl, serviceSource);
    return axios.get<DetailsResponse>(ngsUrl).then((result) => result.data);
}

export function detailsFromLink(link: string, serviceSource: ServiceSource): Promise<DetailsResponse> {
    let ngsUrl = `${ngsBaseURL}${link}&key=${apiKey}`;
    ngsUrl = modifyUrlParams(ngsUrl, serviceSource);
    return axios.get<DetailsResponse>(ngsUrl).then((result) => result.data);
}

type Configuration = {
    baseURL: string;
    apiKey: string;
};

export function configure(configuration: Partial<Configuration>) {
    ngsBaseURL = configuration.baseURL || ngsBaseURL;
    apiKey = configuration.apiKey || apiKey;
}
